import "./UploadLoadingMask.scss";

export interface UploadLoadingMaskProps {
    loading: boolean;
    label?: string;
}

/** 上传控件的局部加载遮罩，避免长耗时上传期间重复选择文件。 */
export default function UploadLoadingMask({ loading, label = "文件上传中" }: UploadLoadingMaskProps) {
    if (!loading) return null;

    return (
        <span
            aria-label={label}
            className="upload-loading-mask"
            role="status"
        >
            <span aria-hidden="true" className="upload-loading-mask__spinner" />
        </span>
    );
}
